import { AuthLanguageSwitcher } from "@/features/i18n/AuthLanguageSwitcher";
import { cn } from "@/lib/utils";
import { Thetis } from "@patient-watch/icons";

const WEBSITE_URL = import.meta.env.VITE_WEBSITE_URL ?? "https://patient.watch";

export function AuthHeader() {
    return (
        <header
            className={cn(
                "flex justify-between items-center bg-indigo-100 dark:bg-slate-900 bg-opacity-50 dark:bg-opacity-50 backdrop-blur-xl px-2 lg:px-4 py-2.5 border-indigo-200 border-y dark:border-slate-500 w-full"
            )}
        >
            <a
                href={WEBSITE_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Patient Watch"
                className="inline-flex items-center gap-x-2 rounded-md px-2 py-1.5 text-slate-800 dark:text-slate-200 text-sm hover:bg-white/80 dark:hover:bg-slate-800 transition-colors"
            >
                <span className="[&_svg]:w-[35px] [&_svg]:h-[35px]">
                    <Thetis />
                </span>
                <span>Patient Watch</span>
            </a>
            <AuthLanguageSwitcher />
        </header>
    );
}
